<script setup lang="ts">
  import MainLayout from 'views/layouts/MainLayout.vue'
  import BoxTitleAssinante from 'components/Assine/BoxTitleCardPlans.vue'
  import BoxTitleCardCredits from 'components/Assine/BoxTitleCardCredits.vue'
  import IconeBds from 'assets/img/logo_BDS_horizontal.png'
  import BgAssine from 'assets/img/bg-pre-assine.webp'
  import ModalMessages from 'components/Modais/ModalMessages.vue'
</script>
<template>
  <MainLayout>
    <div class="slot-body">
      <div class="l-main mt-5">
        <div class="row img-mobile">
          <div class="col-xl-3 col-12 order-1 order-lg-1" v-if="!isMobile()">
            <img :src="BgAssine" alt="Background Pre Assine" />
          </div>
          <div class="col-xl-4 col-12 order-2 order-lg-2">
            <BoxTitleAssinante />
          </div>
          <div class="col-xl-4 col-12 order-3 order-lg-3">
            <BoxTitleCardCredits />
          </div>
        </div>
        <div :class="isMobile()? 'd-flex justify-content-center':'d-flex justify-content-start'">
          <img class="mx-3 mb-5" :src="IconeBds" alt="Logo Horizontal Bella" width="354" />
        </div>
      </div>
    </div>
    <ModalMessages :options="optionsModal" @showModalMessages="showModalMessages" />
  </MainLayout>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { mapState, mapActions } from 'pinia'
  import { localeStore } from '../../stores/locale'
  import { planStore } from 'stores/plans'
  import { isMobile } from 'views/shared/utils/mobile'
  import { userStore } from '../../stores/user'
  import { planCreditStore } from 'stores/planscredits'

  export default defineComponent({
    name: 'AssineOptionsPage',
    head() {
      return {
        templateParams: {
        subTitle: null, 
          subPage: this.locale == 'pt-br' ? 'Assine' : 'Subscribe Now',
          page_url: window.location.origin + this.$route.fullPath,
          page_description:
            this.locale == 'pt-br'
              ? `Quer ver tudo sem censura? Assine agora e tenha acesso ao conteúdo VIP`
              : `Want to see everything uncensored? Subscribe now and get access to VIP content`,
          page_image: '/favicon.ico',
          page_keywords:
            'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
          page_locale: this.locale,
          page_url_pt: 'https://belladasemana.com.br/pt-br/assine',
          page_url_en: 'https://belladasemana.com.br/en/prev/assine',
          page_canonical: 'https://belladasemana.com.br' + this.$route.fullPath
        }
      }
    },
    computed: {
      ...mapState(localeStore, ['locale']),
      ...mapState(planStore, ['plans', 'languagePlans']),
      ...mapState(userStore, ['user', 'isLoggedIn']),
      ...mapState(planCreditStore, ['plansCredits', 'languagePlansCredits'])
    },
    data() {
      return {
        isMobile: isMobile(),
        optionsModal: {
          showModal: false,
          titleModal: 'Erro',
          textBodyModal: '',
          textButtonModal: ''
        }
      }
    },
    methods: {
      ...mapActions(planStore, ['setPlans']),
      ...mapActions(planCreditStore, ['setPlanCredits']),
      showModalMessages({ message }) {
        this.optionsModal.showModal = message.show
        this.optionsModal.titleModal = message.title
        this.optionsModal.textBodyModal = message.textBoby
        this.optionsModal.textButtonModal = message.textButton
      }
    }
  })
</script>

<style scoped lang="css">
  .img-middle {
    width: 100%;
    height: 600px;
    right: -1px;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .img-middle {
      width: 100%;
      height: 392px;
      right: unset;
    }

    .div-shadow::after {
      box-shadow: rgba(0, 0, 0, 0.6) 0px -60px 36px -28px inset;
      content: '';
      display: block;
      width: 97%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      margin-left: 7px;
    }

    .img-mobile {
      margin-left: unset;
      margin-right: unset;
    }
  }
</style>
